import { ChartType } from '@ge/components/charts';
import { chartColors } from '@ge/tokens/charts';
import { globalColors, globalGradients, StateColor, StatusColor } from '@ge/tokens/colors';

// eslint-disable-next-line
export const lightTheme = {
  name: 'Light',
  colors: globalColors,
  backgroundColor: globalColors.white,
  layout: {
    errorColor: globalColors.straw1,
    errorColor2: StatusColor.DANGER,
    textColor: globalColors.black,
    mainBackgroundColor: globalColors.grey7,
    sidebarBackgroundColor: globalColors.grey6,
    sidebarBoxShadow: `-1px 0 0 0 ${globalColors.grey4}, 5px 0 16px 0 rgba(0,0,0,0.3)`,
    sidebarBorderTopColor: globalColors.slate25,
  },
  profile: {
    selectBorderColor: globalColors.stone3,
    borderTopColor: globalColors.grey,
  },
  assetCard: {
    titleBackgroundColor: globalColors.white,
    contentBackgroundColor: globalColors.grey8,
    textColor: globalColors.black,
    secondaryTextColor: globalColors.grey3,
    borderColor: globalColors.grey6,
    iconColor: globalColors.black,
    chevronColor: globalColors.slate3,
    dangerColor: globalColors.red1,
  },
  dangerColor: globalColors.red1,
  mainNav: {
    textColor: globalColors.slate4,
    dataTextColor: globalColors.slate5,
    backgroundColor: globalColors.slate1,
    iconColor: globalColors.slate4,
    sectionBorderColors: globalColors.slate2,
  },
  navigation: {
    iconColor: globalColors.slate5,
    borderColor: globalColors.grey,
    currentRouteDividerColor: globalColors.slate3,
    l1BorderColor: globalColors.grey9,
    linkColor: globalColors.slate5,
    linkActiveBackgroundColor: globalColors.grey9,
    linkActiveColor: globalColors.white,
    linkBorderColor: globalColors.slate2,
    linkActiveBorderColor: globalColors.teal16,
    backgroundColor: globalColors.slate1,
    chevronColor: globalColors.slate4,
    chevronHoverColor: globalColors.teal3,
    dropdownBorderBottomColor: globalColors.teal,
  },
  subNavigation: {
    linkColor: globalColors.grey2,
    linkActiveColor: globalColors.grey1,
    linkBorderColor: globalColors.grey5,
    linkActiveBorderColor: globalColors.teal16,
    linkActiveLegendColor: globalColors.grey16,
  },
  themeSelector: {
    iconColor: globalColors.teal3,
    iconColorActive: globalColors.white,
    chevronColor: globalColors.slate2,
    tabsBackgroundColor: globalColors.grey6,
    tabsIconColor: globalColors.white,
    tabsTextColor: globalColors.white,
    tabsActiveBackgroundColor: globalColors.teal14,
    tabsActiveTextColor: globalColors.white,
    panelBackgroundColor: globalColors.white,
    footerBackgroundColor: globalColors.grey7,
    badgeColor: globalColors.slate4,
    siteActiveBackground: globalColors.straw5,
    toggleTextColor: globalColors.slate5,
    toggleChevronColor: globalColors.slate4,
    toggleChevronActiveColor: globalColors.white,
    toggleTypeIcon: globalColors.slate4,
    filterIconColor: globalColors.slate2,
    filterInputColor: globalColors.black,
    listHeaderColor: globalColors.grey1,
    listBackgroundColor: globalColors.grey6,
    listBackgroundColorOdd: globalColors.grey8,
    listBackgroundActiveColor: globalColors.grey11,
    listButtonColor: globalColors.grey1,
    listBorderColor: 'none',
    selectedTextColor: globalColors.grey7,
    siteIconColor: globalColors.slate1,
    someSitesSelectedIconColor: globalColors.slate1,
    selectAllActiveBackgroundColor: globalColors.grey10,
    borderNavbarInput: globalColors.grey5,
    viewSelector: {
      footerBackgroundColor: globalColors.grey9,
      tabsBackgroundColor: globalColors.slate16,
      iconContainerBackgroundColor: globalColors.slate3,
      backgroundColor: globalColors.grey9,
      textColor: globalColors.grey7,
    },
    modal: {
      backgroundColor: globalColors.slate2,
      boxShadow: '0px 0 25px 0 rgba(0, 0, 0, 0.5)',
      textColor: globalColors.grey5,
    },
    panel: {
      textColor: globalColors.grey1,
      groupOddBackground: globalColors.grey6,
      selectAllColor: globalColors.grey1,
    },
    customView: {
      saveButtonColor: globalColors.white,
      inputBorderColor: globalColors.slate4,
      inputColor: globalColors.white,
    },
  },
  profileNav: {
    backgroundColor: globalColors.slate1,
    borderTopColor: globalColors.grey,
    chevronColor: globalColors.slate4,
    textColor: globalColors.grey7,
    linkIconTextColor: globalColors.slate5,
    linkIconTextActiveColor: globalColors.white,
    linkBorderColor: globalColors.teal16,
    linkActiveBorderColor: globalColors.teal3,
  },
  themeToggle: {
    borderColor: globalColors.grey,
  },
  badge: {
    dismissIconBackgroundColor: globalColors.slate1,
    dismissIconColor: globalColors.slate5,
  },
  button: {
    backgroundColor: `linear-gradient(179.99deg, ${globalColors.white} 0%, ${globalColors.grey6} 63.5%, ${globalColors.grey5} 100%)`,
    border: `solid 1px ${globalColors.grey5}`,
    textColor: globalColors.slate0,
    iconColor: globalColors.slate3,
    fontWeight: 500,
    disabled: {
      fontWight: 300,
      textColor: globalColors.grey4,
    },
    primary: {
      backgroundColor: globalGradients.tealgradient4,
      border: `solid 1px ${globalColors.teal1}`,
      textColor: globalColors.white,
      textShadow: '1px 1px 2px rgba(0,0,0,0.30)',
      fontWeight: 700,
    },
  },
  radioPanel: {
    background: globalColors.teal0,
    caretColor: globalColors.slate5,
    checkedBackgroundColor: globalColors.teal5,
    checkedBorderColor: globalColors.teal,
    disabledTextColor: globalColors.grey2,
  },
  select: {
    primaryBackground: 'linear-gradient(180deg, #006E71 1.04%, #005E60 97.9%)',
    primaryBackground2: 'linear-gradient(180deg, #006E71 1.04%, #005E60 97.9%)',
    primaryBorder: globalColors.teal1,
    primaryTextColor: globalColors.grey7,
    secondaryBackground: globalColors.grey7,
    secondaryBorder: globalColors.grey5,
    secondaryTextColor: globalColors.grey1,
    tertiaryBackground: 'transparent',
    tertiaryBorder: 'transparent',
    tertiaryTextColor: globalColors.grey1,
    basicBackground: 'transparent',
    basicTextColor: globalColors.black,
    labelTextColor: '#9B9B9B',
    optionBackground: globalColors.white,
    optionColor: globalColors.grey1,
    hoverColor: globalColors.teal14,
    chevronColor: globalColors.slate3,
    chevronPrimaryColor: globalColors.white,
    checkmarkColor: globalColors.black,
    errorBorder: `solid 1px ${globalColors.red1}`,
    searchBackground: globalColors.grey7,
    searchBorderColor: globalColors.grey5,
    searchPlaceholderColor: globalColors.grey3,
    footerBoxShadow: globalColors.slate12,
    borderColor: globalColors.grey5,
    recurrenceCustomMenu: {
      backgroundColor: globalColors.grey7,
    },
  },
  videoPlayer: {
    controlBarBackgroundColor: 'rgba(216, 216, 216, 0.15)',
    fullscreenExitIcon: globalColors.slate4,
    iconColor: globalColors.white,
    progressBarBackgroundColor: 'rgba(0, 0, 0, 0.34)',
    progressBarColor: globalColors.white,
  },
  input: {
    border: globalColors.grey5,
    borderNavbarInput: globalColors.grey9,
    invalidBorder: globalColors.red1,
    background: globalColors.white,
    textColor: globalColors.grey1,
    labelTextColor: '#9B9B9B',
    placeholderTextColor: globalColors.grey3,
  },
  checkbox: {
    iconColor: globalColors.teal13,
  },
  radio: {
    borderColor: globalColors.slate4,
    activeColor: globalColors.teal13,
  },
  collapsiblePanel: {
    carotIconColor: globalColors.black,
    subHeader: globalColors.teal2,
  },
  ribbonFilter: {
    textColor: globalColors.grey1,
    dataTextColor: globalColors.grey5,
    backgroundColor: globalColors.white,
    iconColor: globalColors.slate3,
    borderColor: globalColors.grey5,
    activeTextColor: globalColors.white,
    activeBackgroundColor: globalColors.teal1,
  },
  clearColumnFilterBtn: {
    textColor: globalColors.black,
    iconColor: globalColors.slate4,
  },
  table: {
    fixedBorderColor: globalColors.slate25,
    sectionTextColor: globalColors.grey2,
    columnTextColor: globalColors.grey3,
    sidebarHeaderBackgroundColor: globalColors.white,
    headerBackgroundColor: globalColors.white,
    headerBorderColor: globalColors.grey5,
    headerSortColor: globalColors.black,
    dataTextColor: globalColors.grey1,
    dataTextColorLight: globalColors.grey3,
    oddRowColor: globalColors.grey8,
    evenRowColor: globalColors.grey7,
    rowColor: globalColors.white,
    border: globalColors.grey5,
    borderTransparent: globalColors.grey5,
    arrowColor: globalColors.slate4,
    arrowColorRed: globalColors.red2,
    iconErrorColor: globalColors.red2,
    iconInactiveColor: globalColors.slate5,
    iconGreyColor: globalColors.slate4,
    iconLightColor: globalColors.slate4,
    actionsMenuButtonTextColor: globalColors.grey7,
    actionsMenuButtonIconColor: globalColors.slate5,
    actionsMenuButtonBackgroundColor: globalColors.teal1,
    actionsMenuButtonBorderColor: '#237383',
    dataColor: globalColors.slate4,
    noDataColor: globalColors.red2,
    subTitleTextColor: globalColors.grey4,
    hoverColor: globalColors.teal1,
    dragDropBackgroundColor: globalColors.teal2,
    dragDropBorderColor: globalColors.mint5,
    warningIconColor: globalColors.white,
    warningIconBackgroundColor: globalColors.stone1,
    troubleshootingIconColor: globalColors.black,
    hoverBackground: globalColors.grey8,
    textLightColor: globalColors.grey1,
    metricSeparator: globalColors.grey2,
    entityCell: globalColors.teal3,
    iconHighlightColor: globalColors.teal1,
    rowHoverBackground: globalColors.white,
    rowSelectedBackground: globalColors.teal0,
    personIconColor: globalColors.slate4,
    iconCompletedColor: globalColors.pine3,
    iconNotEligibleColor: globalColors.grey2,
  },
  tasksTracker: {
    buttonBackgroundColor: globalColors.slate2,
    buttonSeperatorColor: globalColors.slate1,
    buttonDividerSeperatorColor: globalColors.transparent,
    buttonTextColor: globalColors.grey14,
    buttonSelectedTextColor: globalColors.black,
    addIconButtonColor: globalColors.teal1,
    whiteColor: globalColors.white,
    manageViewsHeaderText: globalColors.grey4,
    defaultViewsText: globalColors.grey7,
    manageViewsCancelBtnColor: globalColors.slate9,
    manageViewsSaveBtnColor: globalColors.teal12,
    inputTextError: globalColors.red2,
    inputBackgroundColor: globalColors.slate1,
    manageViewsDividerColor: globalColors.grey9,
    reorderCancelBtnBorderColor: globalColors.slate12,
    reorderSaveBtnBorderColor: globalColors.teal1,
    manageViewDropdownColor: globalColors.slate3,
    manageViewSectionText: globalColors.grey14,
    manageViewHeaderText: globalColors.grey14,
  },
  damagesTracker: {
    buttonBackgroundColor: globalColors.slate2,
    buttonSeperatorColor: globalColors.slate1,
    buttonTextColor: globalColors.slate5,
    buttonSelectedTextColor: globalColors.black,
    addIconButtonColor: globalColors.teal1,
    whiteColor: globalColors.white,
    manageViewsHeaderText: globalColors.grey4,
    defaultViewsText: globalColors.grey7,
    manageViewsCancelBtnColor: globalColors.slate9,
    manageViewsSaveBtnColor: globalColors.teal12,
    inputTextError: globalColors.red2,
    inputBackgroundColor: globalColors.slate1,
    manageViewsDividerColor: globalColors.grey9,
    reorderCancelBtnBorderColor: globalColors.slate12,
    reorderSaveBtnBorderColor: globalColors.teal1,
  },
  signal: {
    active: globalColors.black,
    disabled: globalColors.grey4,
    warning: globalColors.red2,
  },
  siteStatusBar: {
    backgroundColor: globalColors.grey0,
    available: StateColor.AVAILABLE,
    online: StateColor.ONLINE,
    impacted: StateColor.IMPACTED,
    tripped: StateColor.TRIPPED,
    stopped: StateColor.STOPPED,
    noData: StateColor.NO_DATA,
    netComm: StateColor.NO_DATA,
    maintenance: StateColor.MAINTENANCE,
    repair: StateColor.REPAIR,
  },
  siteProductionBar: {
    backgroundColor: globalColors.grey5,
    spacerColor: globalColors.grey5,
    fillColor: globalColors.grey4,
  },
  miniBarChart: {
    altBackgroundColor: globalColors.blue3,
    backgroundColor: globalColors.stone1,
    warningBackgroundColor: globalColors.orange1,
    dangerBackgroundColor: globalColors.red2,
    fillColor: globalColors.stone3,
    altFillColor: globalColors.white,
    warningFillColor: globalColors.stone3,
    dangerFillColor: globalColors.stone3,
    indicatorColor: globalColors.green3,
    upperIndicatorColor: globalColors.blue6,
    altIndicatorFillColor: globalColors.black,
    warningIndicatorBorderColor: 'rgba(217,133,67,0.50)',
    dangerIndicatorColor: globalColors.red1,
    dangerIndicatorBorderColor: globalColors.red2,
  },
  tabs: {
    borderColor: globalColors.grey5,
    activeBorderColor: globalColors.teal3,
    textColor: globalColors.grey2,
    activeTextColor: globalColors.grey1,
    borderBottom: globalColors.teal16,
  },
  entityDetails: {
    detailsPanelAfter: globalColors.slate12,
    backgroundColor: globalColors.grey6,
    borderColor: globalColors.teal1,
    headerBackground: `linear-gradient(${globalColors.grey8}, white)`,
    headerIconColor: globalColors.grey0,
    hoverIconColor: globalColors.white,
    headerBadgeColor: globalColors.white,
    headerBadgeFontColor: globalColors.black,
    headerBorderColor: globalColors.grey9,
    tabContentBackground: globalColors.white,
    tableHeaderBorder: globalColors.white,
    tableRowBorder: globalColors.grey9,
    sitePanelBlockBackground: globalColors.white,
    sitePanelBlockBorder: globalColors.grey7,
    overviewBlockBackground: globalColors.white,
    overviewBorderColor: globalColors.grey5,
    overviewBlockInsetBackground: globalColors.grey7,
    overviewTableBorderColor: globalColors.white,
    overViewTableHeadTextColor: globalColors.grey0,
    overviewTableBodyTextColor: globalColors.black,
    badgeColor: globalColors.slate5,
    alertIconColor: globalColors.white,
    alertBorderColor: globalColors.red2,
    alertIconInvalidBackgroundColor: globalColors.red2,
    alertIconBackgroundColor: globalColors.slate3,
    buttonInactiveTextColor: globalColors.white,
    overviewLink: globalColors.black,
    siteHeaderIconColor: globalColors.grey12,
    siteHoverColor: globalColors.teal17,
    siteSearchColor: globalColors.white,
    toggleBackground: globalColors.white,
    actionButtons: {
      borderColor: globalColors.grey7,
      textColor: globalColors.grey1,
    },
    tickets: {
      background: globalColors.white,
      iconColor: globalColors.slate1,
      textColor: globalColors.black,
      borderColor: globalColors.grey5,
      actionsColor: globalColors.straw3,
      badgeColor: globalColors.grey5,
      arrowIcon: globalColors.slate3,
      creatorHeader: globalColors.slate3,
    },
    readings: {
      readingHeaderColor: globalColors.grey1,
      readingValueColor: globalColors.grey,
    },
    statusBar: {
      titleBorderColor: globalColors.grey,
      goodColor: globalColors.pine1,
      warnColor: globalColors.straw4,
      errorColor: globalColors.red4,
    },
    actions: {
      backgroundColor: globalColors.white,
      border: `1px solid ${globalColors.grey6}`,
    },
    fhp: {
      backgroundColor: globalColors.white,
      borderBottomColor: globalColors.grey9,
    },
    tasks: {
      details: {
        headerBackground: globalColors.grey8,
        headerText: globalColors.grey0,
        contentBackground: globalColors.white,
        borderRightColor: globalColors.grey5,
        columnButtonColor: globalColors.slate3,
        columnBorder: globalColors.grey5,
        labelColor: globalColors.grey3,
        inputColor: globalColors.grey0,
      },
    },
    cases: {
      details: {
        issueHeaderBackground: globalColors.white,
        contentBackground: globalColors.grey6,
        collapseArrow: globalColors.slate3,
        tableHeaderBorder: globalColors.slate2,
        rowBorder: globalColors.grey5,
        columnSeparator: globalColors.grey5,
        dataTitle: globalColors.black,
        dataDefinition: globalColors.grey1,
        taskHeader: globalColors.grey9,
        resolutionText: globalColors.grey4,
        resolutionDisplay: globalColors.black,
        taskRow: globalColors.slate2,
        selectedTaskRow: globalColors.teal7,
        errorColor: globalColors.red2,
        resolutionBackground: globalColors.white,
        iconColor: globalColors.grey0,
        casePanelTableBackground: globalColors.white,
        addDamagePanelTableBackground: globalColors.white,
      },
    },
    notes: {
      addNote: globalColors.black,
      separator: globalColors.grey5,
      entityInfo: globalColors.grey3,
      entityDescription: globalColors.black,
      tableCopyHeader: globalColors.grey3,
      validSpecialInstruction: globalColors.slate3,
      invalidSpecialInstruction: globalColors.red2,
      toggleButtonActiveColor: globalColors.grey2,
      toggleButtonDisabledColor: globalColors.grey5,
      toggleButtonBorderColor: globalColors.grey4,
      knobActiveColor: globalColors.grey7,
      knobDisabledColor: globalColors.grey7,
      tickColor: globalColors.grey2,
    },
    battery: {
      openColor: globalColors.green2,
      textColor: globalColors.grey4,
      borderColor: globalColors.slate1,
    },
    specialInstructions: {
      badgeCount: globalColors.stone1,
      badgeBackground: globalColors.slate3,
      pastDue: globalColors.straw6,
      oddListBackground: globalColors.white,
      evenListBackground: globalColors.grey7,
      headerColor: globalColors.teal1,
      headerBorder: globalColors.teal8,
      showMore: globalColors.teal,
      textBorder: globalColors.slate1,
    },
    sensorReadings: {},
  },
  sensorReadingsChart: {
    labelColor: globalColors.grey4,
    alertLine: globalColors.red2,
    contextLine: globalColors.stone5,
    backgroundColor: { primary: globalColors.grey7, secondary: globalColors.grey7 },
    borderColor: { secondary: globalColors.slate3 },
    plotBackground: { primary: globalColors.white, secondary: globalColors.white },
    xAxisLabelColor: globalColors.grey0,
    xAxisTitleColor: globalColors.grey0,
    legendColor: globalColors.black,
    legendText: globalColors.black,
    legendValue: globalColors.slate2,
    legendBackground: { primary: globalColors.white },
    legendBorderColor: { secondary: globalColors.slate2 },
    disabledLegendColor: globalColors.grey4,
    disabledIconColor: globalColors.grey4,
    plotBandColor: globalColors.teal3,
    plotLineColors: {
      trip: globalColors.red2,
      high: globalColors.red1,
      medium: globalColors.orange1,
      low: globalColors.blue3,
    },
    colors: [
      [
        globalColors.lavender4,
        globalColors.lavender3,
        globalColors.lavender2,
        globalColors.lavender1,
      ],
      [globalColors.magenta4, globalColors.magenta3, globalColors.magenta2, globalColors.magenta1],
      [globalColors.straw4, globalColors.straw3, globalColors.straw2, globalColors.straw1],
      [globalColors.pine4, globalColors.pine3, globalColors.pine2, globalColors.pine1],
    ],
  },
  gaugeChart: {
    hashes: globalColors.grey6,
    levels: {
      default: {
        bgStart: [globalColors.grey, 0.07],
        bgEnd: [globalColors.grey, 0],
      },
      warning: {
        bgStart: [globalColors.orange1, 0.05],
        bgEnd: [globalColors.orange2, 0.278217876],
      },
      danger: {
        bgStart: [globalColors.red3, 0.05],
        bgEnd: [globalColors.red4, 0.307036713],
      },
      extreme: {
        bgStart: [globalColors.yellow, 1],
        bgEnd: [globalColors.red4, 1],
      },
    },
    needle: {
      colors: {
        default: globalColors.white,
        warning: globalColors.white,
        danger: globalColors.red1,
      },
      border: {
        colors: {
          default: 'transparent',
          warning: globalColors.orange1,
          danger: globalColors.red1,
        },
      },
      boxShadow: {
        default: 'none',
        warning: 'none',
        danger: `0 0 4px 3px ${globalColors.white}`,
      },
    },
    title: globalColors.grey2,
    thresholdBackground: '#A8AFB5',
    thresholdLine: globalColors.slate25,
    thresholdZIndex: 0,
    thresholdBgOpacity: 0.28,
  },
  gaugeStatChart: {
    startGradient: '#EDEDED',
    endGradient: '#F7F7F7',
    textColor: globalColors.grey3,
  },
  sparkLineChart: {
    areaBgColor: globalColors.blue6,
    dangerColor: globalColors.red2,
    defaultLineColor: globalColors.teal3,
  },
  kpiChart: {
    expandButtonColor: globalColors.grey0,
    tooltipSecondaryColor: globalColors.grey2,
  },
  scrollbar: {
    trackBackground: globalColors.grey5,
    thumbBackground: globalColors.white,
    trackActiveBackground: '#CDCDCD',
    thumbActiveBackground: globalColors.white,
    thumbActiveBorder: '#AEB4B9',
    thumbActiveHorizontalBackground: globalColors.slate4,
  },
  sidebar: {
    badgeColor: globalColors.slate3,
    iconColor: globalColors.slate2,
    settingsIconColor: globalColors.slate3,
    boxShadow: '0 9px 9px 0 rgba(0,0,0,0.03)',
    evenRowBackground: globalColors.grey8,
    oddRowBackground: globalColors.grey7,
    textColor: globalColors.grey2,
    editHeaderBackground: globalColors.grey7,
    editBackground: globalColors.white,
    editFooterBackground: globalColors.grey7,
    borderColor: globalColors.grey5,
    listIconColor: globalColors.slate2,
    listActionIconColor: globalColors.slate2,
  },
  countblock: {
    textColor: globalColors.grey3,
    textColorActive: globalColors.grey7,
    textShadow: 'none',
    boxShadow: 'inset 0 1px 2px 0 rgba(0,0,0,0.34)',
    transparentize: 0.75,
  },
  modal: {
    overlay: 'rgba(242,242,242,0.3)',
    background: globalColors.white,
    alertBorderTop: globalColors.slate4,
  },
  dialog: {
    background: globalColors.white,
    iconColor: globalColors.grey3,
    headerBackground: globalColors.grey6,
    headerTextColor: globalColors.grey2,
    closeIconColor: globalColors.grey3,
    footerSeparatorColor: globalColors.grey5,
    taskReschedule: {
      spacerBorderColor: globalColors.grey5,
      labelColor: globalColors.grey2,
      iconColor: globalColors.grey2,
      textColor: globalColors.grey4,
    },
  },
  caseCloseDialog: {
    titleColor: globalColors.grey7,
    badgeColor: globalColors.slate2,
  },
  caseLinkDialog: {
    titleColor: globalColors.grey7,
    warningDialogColor: globalColors.black,
    textColor: '#B3B3B3',
    iconColor: globalColors.slate5,
    inputColor: globalColors.slate4,
    entityInfo: globalColors.grey3,
    assetIconColor: globalColors.slate4,
    entityIconColor: globalColors.slate5,
    headerTitleColor: globalColors.grey7,
    headerSeparatorColor: globalColors.grey5,
    separatorColor: globalColors.slate1,
    errorTextColor: globalColors.red1,
    badgeColor: globalColors.slate3,
    tabBackground: globalColors.slate1,
  },
  filterPanel: {
    titleColor: globalColors.grey1,
    iconColor: globalColors.slate3,
    chevronColor: globalColors.slate4,
    appliedBackgroundColor: globalColors.teal5,
    backgroundColor: globalColors.white,
    borderColor: globalColors.slate4,
    footerBackgroundColor: globalColors.white,
    boxShadow: '0 1px 1px 0 rgba(0,0,0,0.16);',
  },
  menu: {
    backgroundColor: globalColors.white,
    textColor: globalColors.black,
    headerColor: globalColors.grey3,
    titleBackground: globalColors.slate5,
    escalationTitleBackground: globalColors.slate25,
    titleTextColor: globalColors.grey2,
    borderColor: globalColors.grey5,
    tableHeaderTextColor: globalColors.grey4,
    tableBodyTextColor: globalColors.grey3,
    tableChevronColor: globalColors.slate3,
    hoverBackground: globalColors.grey7,
    labelColor: globalColors.slate5,
    actionsMenu: {
      borderColor: globalColors.slate4,
      textColor: globalColors.slate0,
      hoverBackground: globalColors.slate5,
      hoverBorder: globalColors.teal7,
    },
  },
  eventController: {
    iconColor: '#37434E',
    commandDialog: {
      tdBackground: globalColors.grey6,
      tableBackground: globalColors.white,
    },
  },
  tasks: {
    backgroundColor: {
      O: globalColors.blue1,
      T: globalColors.blue2,
      W: globalColors.blue3,
      default: globalColors.slate3,
    },
    newButton: {
      border: `1px solid ${globalColors.slate3}`,
      background: `linear-gradient(
            180deg,
            ${globalColors.slate5} 0%,
            ${globalColors.white} 62.55%,
            ${globalColors.white} 100%
          );`,
    },
  },
  taskStatusBadge: {
    textColor: {
      default: globalColors.white,
      unscheduled: globalColors.white,
      scheduled: globalColors.slate1,
      completed: globalColors.slate1,
      closed: globalColors.white,
    },
    backgroundColor: {
      default: globalColors.slate2,
      unscheduled: globalColors.slate2,
      scheduled: globalColors.teal3,
      completed: globalColors.green4,
      closed: globalColors.slate2,
    },
  },
  taskApprovalFlag: {
    approved: globalColors.pine3,
    notApproved: globalColors.red2,
    bundled: globalColors.lightblue,
  },
  newTaskDialog: {
    label: globalColors.slate0,
    actionButtonText: globalColors.slate2,
    sectionBorder: globalColors.grey6,
    collapsibleIcon: globalColors.slate1,
    recurrenceCustom: globalColors.gre8,
    customEditIcon: globalColors.black,
    okButton: globalColors.slate15,
    dayUnchecked: globalColors.black,
    dayChecked: globalColors.slate15,
    searchText: globalColors.black,
    searchCaret: globalColors.slate15,
    selectMenuBorder: globalColors.grey8,
    selectMenuIcon: globalColors.teal3,
    selectMenuHoverBackground: globalColors.slate5,
    selectMenuHoverBorder: globalColors.teal7,
    headerTitleColor: globalColors.black,
    headerIconColor: globalColors.slate3,
    headerSubtitleColor: globalColors.grey2,
  },
  alertDialog: {
    blockedActionIconColor: globalColors.teal2,
    expandButtonColor: globalColors.teal2,
    tagBackgroundColor: globalColors.slate3,
    tagTextColor: globalColors.grey7,
    viewValueTextColor: globalColors.black,
  },
  tooltip: {
    backgroundColor: globalColors.grey6,
    textColor: globalColors.slate1,
    boxShadow: '0 1px 3px 2px rgba(0,0,0,0.15)',
    backgroundColorActions: globalColors.slate1,
    textColorActions: globalColors.white,
  },
  colorPalatte: {
    color: globalColors.black,
    backgroundColor: globalColors.white,
    boxShadow: '0px 0px 10px 3px #eee',
    colorNameBorder: '1px solid #333;',
  },
  filterMenu: {
    titleColor: globalColors.slate0,
    textColor: globalColors.slate0,
    borderColor: globalColors.slate4,
    searchIcon: globalColors.slate4,
    inputBorderColor: globalColors.slate4,
    inputBackgroundColor: globalColors.white,
    inputspinBackgroundColor: '#161d23',
    icon: {
      default: globalColors.slate4,
      active: globalColors.teal2,
      hover: globalColors.slate2,
      hoverStroke: globalColors.teal3,
    },
  },
  analyze: {
    header: {
      borderBottomColor: globalColors.slate2,
      filterBackground: globalColors.grey6,
      filterBorder: globalColors.grey4,
      statusBorder: globalColors.grey5,
      kpiTitleColor: globalColors.slate0,
      kpiColor: globalColors.slate0,
      kpiDescColor: globalColors.slate0,
      kpiIconColor: globalColors.slate0,
      ledgendColor: globalColors.slate0,
      backButtonTextColor: globalColors.slate0,
      calendarIconColor: globalColors.slate0,
    },
    dashboard: {
      toggleButtonIconColor: globalColors.white,
      settingsButtonIconColor: globalColors.slate3,
      badgeColor: globalColors.slate2,
    },
    filter: {
      shadow: 'rgba(202, 202, 203, 0.5)',
      groupBorder: globalColors.slate8,
      groupHeader: globalColors.slate4,
      collapseArrow: globalColors.slate3,
      collapseHeader: globalColors.slate0,
      showMoreButton: globalColors.slate0,
    },
    regionCard: {
      backgroundColor: globalColors.grey8,
      detailsBackground: globalColors.grey8,
      boxShadow: `3px 0 20px ${globalColors.grey6}`,
      titleBorderColor: globalColors.grey7,
      chartBackgroundColor: globalColors.grey8,
      regionIcon: globalColors.slate1,
      chevronIcon: globalColors.slate2,
      footerColor: globalColors.slate3,
      footerBoxShadow: `0 -14px 14px ${globalColors.grey7}`,
      footerBorder: globalColors.grey2,
      defaultLine: globalColors.mint5,
      targetLine: globalColors.slate2,
      gridLineColor: globalColors.stone4,
      dayVerticalLineColor: globalColors.pine2,
      unitsTextColor: globalColors.grey4,
      toggleButtonInactiveTextColor: globalColors.slate3,
      toggleButtonInactiveColor: `linear-gradient(0deg, ${globalColors.slate15} 0%, ${globalColors.slate2} 100%)`,
      toggleButtonActiveTextColor: globalColors.white,
      toggleButtonActiveColor: `linear-gradient(0deg, ${globalColors.slate2} 0%, ${globalColors.teal1} 100%)`,
      toggleButtonIconColor: globalColors.white,
    },
    table: {
      titleColor: globalColors.grey0,
      newButtonBorderColor: globalColors.grey9,
    },
    columnChart: {
      borderColor: globalColors.grey2,
      textColor: globalColors.grey4,
      activeTextColor: globalColors.slate1,
      gridLineColor: globalColors.grey2,
      dangerFill: globalColors.terracotta4,
      arrowColor: globalColors.white,
      activeBackground: 'rgba(38, 38, 38, 0.09)',
      activeBorder: globalColors.slate5,
      columnColor: globalColors.stone3,
      tooltipPrimaryColor: globalColors.slate1,
      kpiValueColor: globalColors.grey1,
      legendColor: globalColors.stone2,
    },
    pareto: {
      buttonColor: globalColors.slate1,
      disabledButtonColor: globalColors.slate2,
      arrowIconColor: globalColors.slate3,
      titleColor: globalColors.black,
    },
    powerCurveChart: {
      colors: [globalColors.mint3],
      powerCurveColor: globalColors.mint3,
      referenceLineColor: globalColors.grey1,
    },
    splineChart: {
      axisLabelColor: globalColors.grey0,
      gridLineColor: globalColors.grey2,
    },
    stackedColumnChart: {
      axisLabelColor: globalColors.grey0,
      colorRamp: [
        globalColors.straw5,
        globalColors.straw4,
        globalColors.straw3,
        globalColors.straw2,
        globalColors.straw1,
        globalColors.terracotta5,
        globalColors.terracotta4,
        globalColors.terracotta3,
      ],
      columnBorderColor: globalColors.grey7,
      gridLineColor: globalColors.grey2,
      negativeColor: globalColors.teal,
    },
    waterfallChart: {
      gridLineColor: globalColors.grey3,
      gridLabelColor: globalColors.grey4,
      barColor: globalColors.straw4,
      barNestedColor: globalColors.straw2,
      barToggleIconColor: globalColors.slate3,
      highlightedRowBackgroundColor: globalColors.yellow,
    },
    tableBackground: globalColors.white,
    frequencyLineChart: {
      headerIconColor: globalColors.slate3,
      colors: [globalColors.stone2],
      colorsLarge: globalColors.teal3,
      gridLineColor: globalColors.grey2,
      titleColor: globalColors.black,
      badgeColor: globalColors.teal1,
    },
    modeChart: {
      colors: [globalColors.stone2],
      gridLineColor: globalColors.grey2,
      titleColor: globalColors.black,
    },
    regionSparkLineChart: {
      xAxisGridLineColor: globalColors.grey5,
      xAxisLineColor: globalColors.grey4,
      xAxisPlotLineColor: globalColors.teal3,
      yAxisGridLineColor: globalColors.grey4,
      chevronColor: globalColors.slate3,
    },
    metricsPanel: {
      backgroundColor: globalColors.white,
      textColor: StatusColor.DEFAULT,
      labelColor: globalColors.black,
    },
    scatterChart: {
      pointColor: globalColors.grey3,
      gridLineColor: globalColors.grey4,
      averageLineColor: globalColors.teal2,
      averageLineColorLight: globalColors.grey1,
    },
    regionSiteCard: {
      backgroundColor: globalColors.white,
      borderColor: globalColors.grey6,
      dangerBoxShadow: '0 5px 5px 1px rgba(239,83,83,0.5)',
      dangerBorder: '1px solid rgba(239,83,83,0.35)',
      siteSelectHoverBorderColor: globalColors.teal3,
      siteSelectedHoverShadow: '0 0 0 2px rgba(30,105,120,0.5)',
    },
    majorLoss: {
      table: {
        text: globalColors.grey2,
        border: globalColors.grey4,
        hover: {
          background: globalColors.teal4,
          border: globalColors.teal1,
          text: globalColors.white,
        },
        selected: {
          border: globalColors.mint3,
        },
      },
      donutChart: {
        border: '#213545',
        title: globalColors.grey1,
        errorMessageColor: globalColors.grey3,
        selected: globalColors.mint3,
      },
    },
    fullScreenChartModal: {
      backgroundColor: globalColors.grey6,
      borderColor: globalColors.grey2,
      dateTimeColor: globalColors.grey2,
      kpiHeaderColor: globalColors.grey2,
      kpiTextColor: globalColors.black,
      kpiUnitColor: globalColors.grey3,
    },
    site: {
      yAxisTitleColor: globalColors.grey0,
      chartTitleBorder: globalColors.slate2,
      tableSeparator: globalColors.grey2,
    },
    troubleshooting: {
      header: {
        background: globalColors.grey6,
        detailsBackground: globalColors.white,
        actionsBackground: globalColors.teal14,
        actionsBorderColor: globalColors.pine1,
        statusColor: globalColors.teal1,
        titleColor: globalColors.grey6,
        iconColor: globalColors.slate5,
        shadow: '0 1px 4px 0 rgba(0,0,0,0.2)',
        sourceDetails: {
          textColor: globalColors.slate4,
          borderColor: globalColors.slate1,
        },
      },
      card: {
        background: globalColors.white,
        border: globalColors.slate5,
      },
    },
    manualAdjustment: {
      iconsColor: globalColors.grey0,
      panelsColor: globalColors.grey6,
      kpiTitleColor: globalColors.slate0,
      kpiColor: globalColors.slate0,
      kpiDescColor: globalColors.slate0,
      bordersColor: globalColors.grey6,
      eventDialog: {
        backgroundColor: globalColors.white,
        headerBackgroundColor: globalColors.grey6,
        categoryColor: globalColors.black,
        labelColor: globalColors.slate0,
        valueColor: globalColors.grey1,
        bordersColor: globalColors.grey6,
        editButtonColor: globalColors.grey1,
        editButtonIconColor: globalColors.slate3,
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        newEventIconColor: globalColors.slate2,
      },
      chart: {
        timelineColor: globalColors.slate0,
        timelineGridColor: globalColors.grey6,
        entityTitleColor: globalColors.slate0,
        entityNameColor: globalColors.slate0,
        entityIconColor: globalColors.slate2,
        rowBackgroundColor: globalColors.grey6,
        rowAltBackgroundColor: globalColors.grey8,
        activeRowBorderColor: globalColors.teal1,
        activeRowBackgroundColor: globalColors.white,
      },
    },
    gaugeConfiguration: {
      gaugeCardBackground: globalColors.slate6,
      gaugeCardBoxShadow: '2px 2px 2px 0 rgba(0,0,0,0.16)',
      panelBorderColor: globalColors.slate4,
    },
  },
  fullscreenModal: {
    backgroundColor: globalColors.white,
  },
  timeline: {
    tickMark: globalColors.grey4,
    handleColor: globalColors.teal2,
    rangeBackground: 'rgba(191, 191, 191, 0.6)',
  },
  manage: {
    dateHeaderColor: globalColors.grey1,
    dateChevronColor: globalColors.slate3,
    rangeToggle: {
      textColor: globalColors.white,
      activeBackgroundColor: globalGradients.tealgradient4,
      activeBorderColor: globalColors.teal7,
      borderColor: globalColors.teal1,
      backgroundColor: globalColors.grey4,
    },
    calendar: {
      backgroundColor: globalColors.white,
      sideBarBorderColor: globalColors.slate2,
      rangeColor: globalColors.teal1,
      laneBorder: globalColors.slate5,
      groupBySiteAssetIcon: globalColors.slate1,
      laneExpandCaret: globalColors.slate3,
      laneOddBackground: globalColors.grey7,
      laneEvenBackground: globalColors.grey5,
      newCrewBackground: globalColors.grey6,
      newCrewColor: globalColors.slate4,
      newCrewHighlight:
        'inset 0 -2px 0 0 #b8c1c8, inset 0 -4px 6px 0 #a8d1d7, inset 0 1px 6px 0 #a8d1d7',
      editLaneBackground: globalColors.grey7,
      unassignedBackground: globalColors.slate3,
      dragOverBoxShadow:
        'inset 0 -2px 0 0 #b8c1c8, inset 0 -4px 6px 0 #a8d1d7, inset 0 1px 6px 0 #a8d1d7,',
      dispatch: {
        backgroundColor: globalColors.white,
        color: globalColors.black,
        borderColor: globalColors.white,
        textColor: globalColors.slate2,
        turbineIcon: {
          textColor: globalColors.white,
        },
        inprogressMessage: {
          backgroundColor: globalColors.slate3,
        },
        successMessage: {
          backgroundColor: globalColors.teal1,
        },
        failedMessage: {
          backgroundColor: globalColors.red2,
        },
      },
      dispatchTime: {
        color: globalColors.slate2,
      },
    },
    summary: {
      badgeLabelColor: globalColors.slate15,
    },
    timeline: {
      noDataIconColor: globalColors.slate3,
      backgroundColor: globalColors.grey7,
      textColor: globalColors.slate2,
      tickColor: globalColors.grey5,
      scheduleBadge: globalColors.teal3,
      unscheduledBadge: globalColors.slate2,
      completedBadge: globalColors.green4,
      delayBadge: globalColors.slate9,
      borderColor: globalColors.grey3,
      titleColor: globalColors.black,
      dateDarkColor: globalColors.grey2,
      isTodayColor: globalColors.teal2,
      dragDrop: {
        lane: {
          background: globalColors.grey7,
          boxShadow: `inset 0 -3px 6px 0 ${globalColors.teal1}, inset 0 1px 6px 0 ${globalColors.teal1}`,
        },
        cell: {
          boxShadow: globalColors.grey5,
          highlight: {
            border: globalColors.teal3,
            background: globalColors.white,
            boxShadow: `-1px -1px 4px 0 ${globalColors.teal1}, 1px 1px 4px 0 ${globalColors.teal1}`,
          },
          disabled: globalColors.grey2,
        },
      },
    },
    filterMenu: {
      background: globalColors.grey4,
      borderColor: globalColors.slate0,
      chevronColor: globalColors.slate4,
      color: globalColors.slate0,
    },
    crew: {
      titleColor: globalColors.slate1,
      memberColor: globalColors.slate4,
      shadowColor: globalColors.grey6,
    },
    tabs: {
      backgroundColor: globalColors.grey6,
      textColor: globalColors.black,
      borderColor: globalColors.slate2,
      iconColor: globalColors.grey3,
      badge: {
        textColor: globalColors.grey1,
        backgroundColor: globalColors.slate5,
      },
      active: {
        backgroundColor: globalColors.white,
        borderColor: globalColors.teal2,
        textColor: globalColors.black,
        iconColor: globalColors.teal3,
      },
      taskGroup: {
        dashedBorderColor: globalColors.slate4,
        boxShadow: '2px 2px 2px 0 rgba(0,0,0,0.16)',
        textColor: globalColors.slate2,
        iconColor: globalColors.slate2,
      },
      techs: {
        borderColor: globalColors.grey5,
        primaryColor: globalColors.teal1,
        boxShadow: '0 1px 2px 0 rgba(210,208,208,0.71)',
        iconColor: globalColors.slate3,
        crew: {
          containerColor: globalColors.grey6,
          descriptionTitle: globalColors.slate4,
          backgroundColor: globalColors.grey7,
          evenBackgroundColor: globalColors.grey8,
          headerText: globalColors.grey2,
          deleteBoxShadow: 'inset 0 -1px 2px 0 rgba(0,0,0,0.14)',
          addTextColor: globalColors.slate2,
          hover: {
            background: globalColors.grey6,
            shadow: 'inset 0 1px 0 0 #9bd9e4, inset 0 -1px 0 0 #9bd9e4',
          },
          actionButtonsBorder: globalColors.slate2,
        },
        technician: {
          textColor: globalColors.slate1,
          hoursBackground: '#F9F9F9',
          chevronBackground: '#EFF6F7',
          statusColor: globalColors.slate3,
        },
      },
    },
    search: {
      borderColor: `1px solid ${globalColors.grey5}`,
      shadow: 'inset 0 0 2px 0 rgba(0,0,0,0.3)',
      iconColor: globalColors.slate2,
      filterTextColor: globalColors.mint2,
    },
    taskItem: {
      borderColor: globalColors.stone4,
      borderBottomColor: globalColors.grey6,
      locationColor: globalColors.grey2,
      textColor: globalColors.slate1,
      iconColor: globalColors.slate2,
      buttonColor: globalColors.slate2,
      taskTypeColor: globalColors.teal2,
      hover: {
        backgroundColor: '#EEF6F7',
        borderColor: '#9BD9E4',
        actionsBackground: globalColors.teal0,
      },
    },
    dayCard: {
      siteIconColor: globalColors.teal1,
      dashedBorderColor: globalColors.slate4,
      borderColor: globalColors.grey1,
      textColor: globalColors.slate4,
      iconColor: globalColors.teal1,
      crewBackgroundColor: globalColors.shadow,
      crewTextColor: globalColors.slate1,
      crewTextColorInActive: globalColors.slate1,
      crewBackgroundColorActive: globalColors.lightblue,
      crewBorderColor: globalColors.white,
      specialistBackgroundColor: globalColors.violet6,
      specialistTextColor: globalColors.slate2,
      AddTechCircleBoxShadow: '0 0 0 3px rgba(144, 211, 224, 0.5)',
      estimate: {
        boxShadow: '0 2px 2px 0 rgba(11,13,14,0.3)',
      },
      gradients: {
        default: `repeating-linear-gradient(45deg,  ${globalColors.white},  ${globalColors.white} 2px, ${globalColors.grey8} 2px,  ${globalColors.grey8} 4px);`,
        edit: `repeating-linear-gradient(45deg,  ${globalColors.white},  ${globalColors.white} 2px, ${globalColors.grey8} 2px,  ${globalColors.grey8} 4px);`,
        estimate: `repeating-linear-gradient(45deg, transparent, transparent 2px, ${globalColors.grey7} 2px,  ${globalColors.grey7} 4px);`,
        estimateScheduled: `repeating-linear-gradient(45deg, transparent, transparent 2px, ${globalColors.grey6} 2px,  ${globalColors.grey6} 4px);`,
        recommendedHover: `repeating-linear-gradient(45deg, ${globalColors.teal0}, ${globalColors.teal0} 2px, ${globalColors.mint6} 2px, ${globalColors.mint6} 4px);`,
      },
      detail: {
        borderColor: globalColors.grey5,
        dashedBorderColor: globalColors.slate3,
        taskBackground: globalColors.white,
      },
      scheduled: {
        backgroundColor: globalColors.teal0,
        boxShadow: '2px 2px 1px 0 rgba(0,0,0,0.16)',
        textColor: globalColors.slate2,
        gradient: `repeating-linear-gradient(45deg, ${globalColors.white}, ${globalColors.white} 5px, ${globalColors.grey5} 5px,  ${globalColors.grey5} 6px);`,
        crewBackgroundColor: '#B6E1E9',
        crewTextColor: globalColors.slate2,
      },
      travel: {
        textColor: globalColors.stone3,
        iconColor: globalColors.stone3,
      },
      location: {
        textColor: globalColors.grey2,
        backgroundColor: globalColors.stone4,
      },
      hoverText: globalColors.slate2,
      headerHover: globalColors.teal3,
      hoverBoxShadow: globalColors.teal5,
      hoverBorder: globalColors.teal3,
      editBoxShadow: globalColors.teal1,
    },
    cards: {
      scheduledColor: globalColors.teal3,
      unscheduledColor: globalColors.slate3,
      border: '1px solid rgba(28, 37, 45, 0.18)',
      scheduledTextColor: globalColors.grey1,
      unscheduledTextColor: globalColors.white,
      scheduledTypeTextColor: globalColors.teal1,
      unscheduledTypeTextColor: globalColors.teal3,
      selectedBorder: globalColors.teal1,
      selectedHalo: globalColors.teal6,
      scheduledIconColor: globalColors.slate2,
      unscheduledIconColor: globalColors.slate5,
      completedColor: globalColors.green4,
      completedTextColor: globalColors.grey1,
      delaysColor: globalColors.slate0,
      delaysTextColor: globalColors.teal0,
      delaysTypeTextColor: globalColors.slate6,
      completedIconColor: globalColors.slate2,
      completedTypeTextColor: globalColors.teal1,
      stack: {
        boxShadow: '2px 2px 2px 0 rgba(0,0,0,0.25)',
      },
      trBorderBottom: 'rgb(149 149 149 / 0.35)!important',
      thBorderBottom: globalColors.white,
      bundleBadge: globalColors.grey3,
    },
    weather: {
      backgroundColor: globalColors.slate1,
      tempIconColor: globalColors.terracotta4,
      windIconColor: globalColors.teal2,
      expand: {
        backgroundColor: 'linear-gradient(179.99deg, #EDEDED 0%, #F7F7F7 36.65%, #F7F7F7 100%)',
        textColor: globalColors.grey2,
        iconColor: globalColors.black,
      },
    },
  },
  admin: {
    popup: {
      backgroundColor: globalColors.slate2,
      borderColor: globalColors.slate12,
    },
    actionHeader: {
      borderColor: globalColors.slate2,
      iconColor: globalColors.slate4,
      linkColor: globalColors.black,
      removeContainerBackground: globalColors.teal10,
    },
    tenantHeader: {
      background: globalGradients.tealgradient4,
      borderColor: globalColors.teal2,
      boxShadow: '0 1px 4px 0 rgba(0,0,0,0.2)',
      iconColor: globalColors.white,
      textColor: globalColors.white,
    },
    people: {
      backToGlobalButtonColor: globalColors.slate0,
    },
    panel: {
      backgroundColor: globalColors.grey7,
      border: globalColors.grey4,
      header: {
        backgroundColor: globalColors.white,
        borderColor: globalColors.grey4,
        gradient: 'linear-gradient(180deg, #38434E 0%, #445A6C 100%)',
        iconColor: globalColors.slate4,
      },
      steps: {
        number: globalColors.slate2,
        numberActive: globalColors.teal2,
        textColor: globalColors.slate2,
        textColorActive: globalColors.black,
      },
      body: {
        backgroundColor: globalColors.white,
        border: globalColors.slate1,
        detailButton: globalColors.black,
        subHeader: globalColors.slate1,
        collapseArrow: globalColors.slate2,
        check: globalColors.black,
        panelHighlight: 'rgba(32, 57, 61, 0.5)',
        textButton: globalColors.black,
      },
      entityRow: {
        border: globalColors.slate12,
        dark: globalColors.white,
        highlight: globalColors.teal0,
        highlightBorder: globalColors.teal7,
        icon: globalColors.slate4,
        light: globalColors.grey7,
      },
    },
  },
  charts: {
    [ChartType.AREA]: {
      color: globalColors.slate0,
    },
    [ChartType.AREA_SPLINE]: {
      color: globalColors.slate0,
    },
    [ChartType.ROSE]: {
      colors: [
        globalColors.mint5,
        globalColors.mint3,
        globalColors.blue4,
        globalColors.blue3,
        globalColors.straw5,
        globalColors.straw4,
        globalColors.terracotta4,
      ],
    },
    axisTitleColor: globalColors.grey0,
    // might need to revisit if same color scheme works for both dark and light
    colors: [globalColors.stone2, ...chartColors.level1],
    [ChartType.COLUMN]: {
      negativeColor: globalColors.terracotta3,
    },
    [ChartType.MIRROR_COLUMN]: {
      negativeColors: [
        {
          color: globalColors.stone3,
          patternColor: globalColors.stone1,
          selectedColor: globalColors.mint3,
          selectedPatternColor: globalColors.mint1,
        },
        {
          color: globalColors.terracotta3,
          patternColor: globalColors.terracotta1,
          selectedColor: globalColors.mint3,
          selectedPatternColor: globalColors.mint1,
        },
      ],
    },
    gridLineColor: globalColors.grey2,
    legendTitleColor: globalColors.grey0,
    lineColor: globalColors.grey2,
    [ChartType.PARETO]: {
      selectedColor: globalColors.mint3,
      dangerColor: globalColors.red2,
      barToggleIconColor: globalColors.slate3,
      colors: [
        globalColors.straw5,
        globalColors.straw4,
        globalColors.straw3,
        globalColors.straw2,
        globalColors.straw1,
        globalColors.terracotta5,
        globalColors.terracotta4,
        globalColors.terracotta3,
      ],
      nestedColor: globalColors.straw2,
    },
    selectedColor: globalColors.mint3,
    tooltipBackgroundColor: globalColors.grey8,
    tooltipColor: globalColors.grey0,
    borderColor: globalColors.slate3,
    selectedPoint: {
      fillColor: globalColors.teal0,
      lineColor: globalColors.teal2,
    },
    [ChartType.HEAT_MAP]: {
      nullColor: globalColors.pine3,
      stops: [
        [0.0, globalColors.red2],
        [0.3, globalColors.terracotta5],
        [0.5, globalColors.grey10],
        [0.7, globalColors.blue3],
        [1.0, globalColors.pine3],
      ],
    },
  },
  quickEdit: {
    borderColor: globalColors.slate1,
    labelColor: globalColors.grey3,
    saveColor: globalColors.teal3,
    addButtonText: globalColors.black,
  },
  datePicker: {
    backgroundColor: globalColors.white,
    monthTitleColor: globalColors.slate2,
    dayHeaderColor: globalColors.grey4,
    chevronColor: globalColors.slate4,
    day: {
      color: globalColors.grey3,
      selectedBackground: globalColors.teal1,
      selectedColor: globalColors.white,
      outsideMonthColor: globalColors.grey5,
      highlightColor: globalColors.teal2,
      highlightTextColor: globalColors.slate0,
      hoverTextColor: globalColors.black,
    },
    time: {
      backgroundColor: globalColors.white,
      inputColor: globalColors.slate3,
      OuterfontColor: globalColors.slate0,
      dropDownBackgroundColor: globalColors.white,
      dropDownFontColor: globalColors.grey3,
      highlightColor: globalColors.teal2,
      highlightBorderColor: globalColors.teal,
      highlightTextColor: globalColors.slate0,
      errorColor: StatusColor.DANGER,
    },
  },
  assetOverview: {
    header: {
      textColor: globalColors.slate0,
      secondaryTextColor: globalColors.grey1,
      backButtonTextColor: globalColors.slate0,
      iconColor: globalColors.grey0,
      assetIconBorder: globalColors.teal2,
    },
    issuesSidebar: {
      backgroundColor: globalColors.white,
      headerBorderColor: globalColors.grey5,
      itemBorderColor: globalColors.slate3,
      sidebarIcons: globalColors.black,
    },
    selectAssetInfo: {
      borderColor: globalColors.red2,
      textColor: globalColors.red2,
    },
  },
  dataExplorer: {
    focusAssetColor: globalColors.stone1,
    header: {
      backgroundColor: globalColors.white,
      borderColor: globalColors.grey5,
      iconColor: globalColors.grey0,
      addIconColor: globalColors.slate4,
      removeIconColor: globalColors.slate4,
      assetBar: {
        backgroundColor: `linear-gradient(180deg, ${globalColors.grey7} 0%, ${globalColors.grey5} 100%)`,
        boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.2)',
        actionsBorderColor: globalColors.slate1,
        textColor: globalColors.grey1,
        borderColor: globalColors.white,
        selectedBorderColor: globalColors.slate1,
        assetBoxShadow: 'rgba(30, 105, 120, 0.5)',
      },
    },
    filters: {
      headerButton: globalColors.slate0,
      headerIconColor: globalColors.slate2,
      searchIconColor: globalColors.slate5,
      layoutIconSelected: globalColors.white,
      layoutIcon: globalColors.slate3,
    },
    charts: {
      selectedAssetColor: globalColors.stone4,
      selectedPointsColor: globalColors.green0,
      container: {
        labelColor: globalColors.slate2,
        selectColor: globalColors.slate2,
        promoteIconColor: globalColors.slate2,
      },
      editIconColor: globalColors.slate3,
      buttonColor: globalColors.slate0,
      buttonBackground: globalColors.white,
      buttonIconColor: globalColors.slate5,
      iconColor: globalColors.grey0,
      tooltipColor: globalColors.grey4,
      tooltipBorderColor: globalColors.slate1,
      tooltipHeadingColor: globalColors.slate5,
      tooltipKpiNameColor: globalColors.grey4,
      tooltipKpiValueColor: globalColors.grey7,
      xLegendColor: globalColors.grey7,
      yLegendColor: globalColors.grey4,
      xAxisTitleColor: globalColors.grey4,
      yAxisTitleColor: globalColors.grey4,
      xAxisLabelColor: globalColors.grey4,
      yAxisLabelColor: globalColors.grey4,
      gridLineColor: globalColors.grey2,
      plotBandColor: globalColors.teal3,
      plotLineColors: {
        trip: globalColors.red2,
        high: globalColors.red1,
        medium: globalColors.orange1,
        low: globalColors.blue3,
      },
      colors: [
        chartColors.level2[6],
        chartColors.level2[7],
        chartColors.level2[2],
        chartColors.level2[1],
        chartColors.level2[3],
        chartColors.level2[4],
        chartColors.level2[5],
        chartColors.level2[8],
        chartColors.level2[0],
      ],
    },
    dialog: {
      backgroundColor: globalColors.white,
      activeSectionBackgroundColor: globalColors.grey8,
      listBorderColor: globalColors.grey6,
      listActiveColor: globalColors.teal0,
      arrowColor: globalColors.slate5,
      activeArrowColor: globalColors.slate0,
      sectionBorderColor: globalColors.grey5,
      search: {
        iconColor: globalColors.slate4,
        placeholderColor: globalColors.slate3,
        textColor: globalColors.slate1,
        borderColor: globalColors.grey9,
      },
      listHoverBackground: globalColors.slate5,
      listHoverBorder: globalColors.teal7,
    },
  },
  dataLoader: {
    retryColor: globalColors.teal2,
    iconColor: globalColors.grey1,
    descriptionColor: globalColors.grey4,
  },
  underConstruction: {
    iconColor: globalColors.grey4,
    titleColor: globalColors.grey4,
    descriptionColor: globalColors.grey1,
  },
  notification: {
    background: globalColors.teal1,
    borderError: globalColors.red1,
    borderSuccess: globalColors.teal1,
    textColor: globalColors.grey7,
    failureBackground: globalColors.red2,
  },
  taskBadge: {
    backgroundColorClosed: globalColors.blue5,
    backgroundColorOpen: globalColors.blue3,
    borderColorClosed: globalColors.blue3,
    borderColorOpen: globalColors.blue1,
    textColorOpen: globalColors.white,
    textColorClosed: globalColors.slate1,
  },
  severity: {
    immediateFillColor: globalColors.red1,
    highFillColor: globalColors.orange1,
    mediumFillColor: globalColors.straw4,
    lowFillColor: globalColors.lavender4,
    defaultFillColor: globalColors.lavender4,
    sfTimeWindowFillColor: globalColors.blue1,
  },
  lasso: {
    background: 'rgba(133, 205, 219, 0.18)',
    borderColor: globalColors.teal1,
  },
  fileUpload: {
    backgroundColor: globalColors.grey8,
    borderColor: globalColors.grey5,
    filenameTextColor: globalColors.grey0,
    textColor: globalColors.grey1,
    trashIconColor: globalColors.grey0,
    uploadButtonBackgroundColor: globalColors.grey6,
    uploadButtonBorderColor: globalColors.grey4,
    uploadIconColor: globalColors.grey2,
    errorBorderColor: globalColors.red1,
    errorTextColor: globalColors.red1,
  },
  statusMenu: {
    borderColor: globalColors.grey1,
  },
  postProcess: {
    annotationsBackgroundColor: globalColors.grey6,
    annotationsHeaderBackgroundColor: globalColors.slate5,
    annotationsHeaderColor: globalColors.grey1,
    containerHeaderColor: globalColors.slate3,
    infoBackgroundColor: globalColors.slate2,
    parameterCardTitleColor: globalColors.grey2,
    settingsLabel: globalColors.grey4,
    backgroundColor: globalColors.slate1,
    editIconColor: globalColors.slate5,
    videoGalleryBackground: globalColors.grey6,
    iconToolsBackground: 'rgba(0, 0, 0, 0.4)',
    iconButton: '#979797',
    selectedIconButton: '#237383',
    noImageContainerColor: globalColors.grey5,
    hotkeyColor: '#efefef',
    annotationLabelColor: globalColors.grey4,
    inputBackgroundColor: globalColors.grey1,
    inputColor: globalColors.slate3,
    inputBorder: `solid 1px ${globalColors.grey9}`,
    disabledSelectBackground: globalColors.slate2,
    disabledSelectBorder: `solid 1px ${globalColors.slate12}`,
  },
  annotation: {
    containerBackgroundColor: globalColors.slate2,
    containerHeaderColor: globalColors.slate25,
    capsuleColor: globalColors.grey7,
    capsuleSelectedColor: '#efefef',
    ADRColor: globalColors.pine3,
    humanColor: globalColors.terracotta4,
    thirdPartyColor: globalColors.straw3,
    checkedBorderColor: globalColors.mint2,
    actionMenu: {
      menuHeaderBackgroundColor: globalColors.grey6,
      menuHeaderTextColor: globalColors.mint2,
      menuItemBackgroundColor: globalColors.white,
      menuItemTextColor: globalColors.slate1,
      menuItemSeparatorColor: globalColors.grey6,
      badgeBorderColor: globalColors.mint2,
    },
  },
  reportGeneration: {
    borderColor: globalColors.slate4,
    forms: {
      labels: {
        textColor: globalColors.slate1,
      },
      enabled: {
        backgroundColor: globalColors.white,
        borderColor: globalColors.grey5,
        textColor: globalColors.grey1,
      },
      disabled: {
        backgroundColor: globalColors.grey7,
        borderColor: globalColors.grey5,
        textColor: globalColors.grey11,
      },
    },
  },
  escalationDialog: {
    textColor: globalColors.slate4,
    contactInfoColor: globalColors.grey1,
  },
  caseProcedure: {
    subHeader: globalColors.grey12,
    linkColor: globalColors.blue5,
    headerColor: globalColors.grey3,
    subTitleColor: globalColors.grey3,
    titleColor: globalColors.teal3,
    noCaseProcedure: globalColors.straw6,
    handlingProcedureHead: globalColors.grey3,
    handlingProcedureText: globalColors.grey2,
  },
  createReport: {
    sidebarBackgroundColor: globalColors.slate12,
    headerBorderColor: globalColors.slate1,
    headerIconColor: globalColors.grey1,
    headerTextColor: globalColors.white,
    importTextDownload: globalColors.black,
    sidebar: {
      altTextColor: globalColors.grey4,
      separationColor: globalColors.slate2,
      altSeparationColor: globalColors.slate1,
      titleColor: globalColors.grey7,
      labelColor: globalColors.grey5,
      errorLabelColor: globalColors.red4,
      siteIconColor: globalColors.slate4,
      collapseIconColor: globalColors.teal3,
      readOnlyLabelColor: globalColors.grey4,
      parameterValueColor: globalColors.grey7,
      moduleBackgroundColor: globalColors.slate1,
      moduleBorderColor: globalColors.slate4,
      moduleChevronColor: globalColors.slate3,
      moduleHeaderColor: globalColors.grey5,
      moduleHeaderIconColor: globalColors.slate4,
      moduleHeaderLinkColor: globalColors.slate5,
      moduleHeaderColorNotVisible: globalColors.slate4,
      moduleIconColorActive: globalColors.teal2,
      moduleIconColorDisabled: globalColors.slate3,
      moduleIconColorVisible: globalColors.slate4,
      moduleIconColorNotVisible: globalColors.slate5,
      clearAllColor: globalColors.slate5,
    },
    template: {
      headerBackgroundColor: globalColors.white,
    },
    widget: {
      backgroundColor: globalColors.white,
      borderColor: globalColors.grey6,
      headerBorderColor: globalColors.grey5,
      headerIconColor: globalColors.slate4,
      headerTextColor: globalColors.grey2,
      headerLabelColor: globalColors.grey2,
      headerValueColor: globalColors.slate1,
      timestamp: globalColors.grey4,
      list: {
        oddRowColor: globalColors.grey7,
        tableCellTextColor: globalColors.black,
        unitsTextColor: globalColors.grey1,
      },
      notes: {
        titleTextColor: globalColors.grey1,
        bodyTextColor: globalColors.grey3,
      },
      table: {
        backgroundColor: globalColors.white,
        evenRowColor: 'none',
        oddRowColor: globalColors.grey8,
        entriesLabelColor: globalColors.grey2,
        unitsLabelColor: globalColors.grey4,
        variationLabelColor: globalColors.grey4,
      },
      assetStatus: {
        turbineIconColor: globalColors.slate4,
        borderColor: globalColors.slate15,
      },
      plannedWork: {
        includeTextColor: '#6fa4b3',
        techBadge: {
          background: globalColors.slate5,
          border: globalColors.slate5,
          textColor: globalColors.slate1,
        },
        expectedParts: {
          partNumberTextColor: '#6a7278',
        },
      },
      completedWork: {
        includeTextColor: '#6fa4b3',
        techBadge: {
          background: globalColors.slate5,
          border: globalColors.slate5,
          textColor: globalColors.slate1,
        },
        expectedParts: {
          partNumberTextColor: '#6a7278',
        },
      },
      contractualAvailability: {
        includeTextColor: '#6fa4b3',
        rowBorderColor: globalColors.slate3,
      },
      availability: {
        filterLabelColor: globalColors.black,
        lineLabelColor: globalColors.grey4,
        lineUnitsColor: globalColors.black,
      },
      averageWindSpeed: {
        lineLabelColor: globalColors.grey4,
        lineColor: globalColors.blue4,
        lineUnitsColor: globalColors.black,
      },
      productionGraph: {
        chartLabelColor: globalColors.black,
        labelColor: globalColors.grey4,
        totalValueColor: globalColors.black,
        valueLabelColor: globalColors.black,
      },
      manuallyAdjustedEvents: {
        includeTextColor: globalColors.grey2,
      },
      productionTable: {
        includeTextColor: '#6fa4b3',
        rowBorderColor: globalColors.slate3,
      },
    },
    sendReportModal: {
      titleColor: globalColors.grey7,
      labelColor: globalColors.grey4,
      errorLabelColor: globalColors.red4,
      parameterColor: globalColors.grey7,
      separationColor: globalColors.slate1,
    },
  },
  distributionListTable: {
    recipients: globalColors.slate3,
    recipientsCount: globalColors.white,
    title: globalColors.black,
    borderColor: globalColors.darkgray,
  },
  customDropdown: {
    backgroundColor: globalColors.grey7,
    border: globalColors.black,
    color: globalColors.black,
    icon: globalColors.slate3,
  },
  comingSoon: {
    backgroundColor: globalColors.grey7,
    titleColor: globalColors.grey,
    descriptionColor: globalColors.grey4,
    linkColor: globalColors.teal2,
  },
  // Todo : update light theme colors
  customSelect: {
    optionsBorder: globalColors.slate12,
    optionHover: globalColors.teal7,
    optionSelected: globalColors.teal4,
    scrollBar: globalColors.slate25,
  },
  distributionListSidePanel: {
    header: globalColors.slate12,
    headerShadow: globalColors.slate25,
    headerIcon: globalColors.grey13,
    headerTitle: globalColors.white,
    tabNumber: globalColors.slate2,
    tabNumberSelected: globalColors.teal2,
    tabTextSelected: globalColors.white,
    tabText: globalColors.slate4,
    formBackground: globalColors.grey9,
    checkbox: globalColors.grey7,
    checkboxContainer: globalColors.grey4,
    defaultTextLabel: globalColors.grey5,
    InputWrapper: globalColors.slate1,
  },
  errorBoundaryDialog: {
    errorMessageText: globalColors.slate0,
  },
  eventSeverity: {
    safetyCriticalExclamatory: globalColors.white,
    safetyCritical: globalColors.red2,
    falutAlarm: globalColors.red2,
    warning: globalColors.straw4,
    informational: globalColors.blue3,
    danger: globalColors.red4,
    dangerBg: globalColors.red2,
    safetyTrip: globalColors.orange2,
    trip: globalColors.orange2,
    impact: globalColors.straw4,
    level5: globalColors.violet3,
    level6: globalColors.blue4,
    informationAlt: globalColors.green3,
    level1RowBg: 'rgba(239, 83, 83, 0.45)',
    level2RowBg: 'rgba(255, 158, 81, 0.12)',
    pinnedSeparatorBg: globalColors.stone4,
  },
  deleteCaseTemplate: {
    backgroundColor: globalColors.grey7,
    borderBottomColor: globalColors.teal3,
    buttonDividerColor: globalColors.grey9,
    cancelBorderColor: globalColors.black,
    iconColor: globalColors.black,
    caseTitleColor: globalColors.black,
    modalDividerColor: globalColors.slate12,
  },
  taskFlag: {
    caseTitleColor: globalColors.black,
    cancelBorderColor: globalColors.black,
    buttonDividerColor: globalColors.grey9,
  },
  limitSelectAll: {
    backgroundColor: globalColors.grey6,
    tooltipTextColor: globalColors.slate1,
    modalTextColor: globalColors.red2,
  },
  malAdjustmentTable: {
    textColor: globalColors.white,
    approvedIconColor: globalColors.white,
    iconColor: globalColors.slate4,
    approveRejectSelectionSection: {
      backgroundColor: globalColors.grey7,
      btntextColor: globalColors.slate0,
      btnbgColor: globalColors.slate2,
      borderBottomColor: globalColors.teal2,
      btnBorderColor: globalColors.slate12,
    },
    notesMenu: {
      headerBgColor: globalColors.slate3,
      bodyBgColor: globalColors.slate2,
      bodyTextColor: globalColors.grey4,
      bodyNoteColor: globalColors.grey5,
      dividerColor: globalColors.grey9,
    },
    assetsMenu: {
      headerBgColor: globalColors.slate3,
      headerTextColor: globalColors.grey5,
      bodyBgColor: globalColors.slate2,
      bodyTextColor: globalColors.white,
      dividerColor: globalColors.grey9,
      noteBageBgColor: globalColors.slate25,
      noteBageColor: globalColors.white,
    },
    malStatusModal: {
      modalBgColor: globalColors.grey6,
      caretIconColor: globalColors.slate3,
      malContainerBgColor: globalColors.grey5,
      tableTextColor: globalColors.grey5,
      tableDividerColor: globalColors.grey9,
      dividerColor: globalColors.slate1,
      statusTextColor: globalColors.grey7,
      approvedIconColor: globalColors.slate5,
      notesTextColor: globalColors.grey4,
      cancelBtnBorderColor: globalColors.grey5,
      cancelBtnBgColor: globalColors.grey6,
      cancelBtnColor: globalColors.slate0,
      confirmBtnBorderColor: '#005E60',
      confirmBtnBgColor: '#006E71',
      confirmBtnColor: globalColors.slate0,
    },
  },
  delaysModal: {
    border: globalColors.grey15,
    color: globalColors.grey16,
  },
  caseDamages: {
    textColor: globalColors.grey1,
    selectionBgColor: globalColors.grey6,
    selectionBorderColor: globalColors.teal3,
    seperatorColor: '#979797',
    detachBtnBgColor: globalColors.grey7,
    detachBtnBorderColor: globalColors.grey5,
    cancelBtnBgColor: globalColors.grey7,
    cancelBtnBorderColor: globalColors.grey5,
    confirmBtnBorderColor: '#005E60',
    confirmBtnBgColor: '#006E71',
  },
  multiDaySchedule: {
    taskRow: globalColors.grey5,
    textColor: globalColors.slate12,
    subTitleColor: globalColors.grey4,
  },
};
